import { AccountCircle } from "@mui/icons-material";
import { Grid } from "@mui/material";
import React from "react";
import styled from "styled-components";

const SingleInstaler = () => {
  return (
    <Singleinstaller>
      <Grid container spacing={3}>
        <Grid item md={3} xs={12}>
          <div className="person">
            <div className="name">
              <AccountCircle />
              <span className="data">AHmed</span>
            </div>
          </div>
        </Grid>
        <Grid item md={9} xs={12}>
          ahmed
        </Grid>
      </Grid>
    </Singleinstaller>
  );
};

const Singleinstaller = styled.section``;
export default SingleInstaler;
